/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetRecommendationsModel,
  IGetRecommendationsRequest,
  IMappers,
  IGetRecommendationsResponse,
  IGetRecommendationsResponseError,
  TGetRecommendationsResponse,
} from './types';

const defaultConfig: TGetRecommendationsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v1/get-recommendations/',
  hostType: 'api',
} as TGetRecommendationsModel;

function createGetRecommendationsModel(parameters: IGetRecommendationsRequest): TGetRecommendationsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetRecommendationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetRecommendationsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetRecommendations<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetRecommendationsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetRecommendationsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetRecommendationsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendationsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetRecommendationsResponseError);
    }
  }

  return { response, statusCode } as TGetRecommendationsResponse;
}

export { defaultConfig, createGetRecommendationsModel, fetchGetRecommendations };
